import { Component, Input, Output, EventEmitter } from '@angular/core';
import { UploadComponent } from 'src/app/@core/models/item-component';

@Component({
  selector: 'app-editor-component-upload-config',
  templateUrl: 'upload-config.component.html'
})
export class EditorUploadConfigComponent {
  @Input() item: UploadComponent;
  @Input() customData: any;
  @Output() public sendEvent = new EventEmitter<any>();

  constructor() { }

  setAlign(element: any, align: string) {
    element.align = align;
  }

  setElementAlign(element: any, align: string) {
    this.item[element] = align;
  }

  emitSendEvent() {
    this.sendEvent.emit();
  }

}
